import { ParametrosWSBase, DestinoConexion } from "../../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../../EncabezadoRespuestaInterna";

export function CrearRegistroRest_Parametros(datos: any, crc: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "CrearRegistro",
    rutaEndPoint: "/EnterpriseFlows/Sel/CrearRegistroRest",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
    cRC: crc,
  };

  return par;
}

export interface CrearRegistroSelInputMessage {
  IdPreReg: string;
  Cuenta: string;
  Password: string;
  Email: string;
  Telf: string;
  Servicio: string;
  Tipo: string;
}

export interface CrearRegistroRest_Entrada {
  CrearRegistroSelInputMessage: CrearRegistroSelInputMessage;
}

export function builtRegistrarCuentaRest_Entrada(
  l_CrearRegistroSelInputMessage: CrearRegistroSelInputMessage
) {
  var retorno: CrearRegistroRest_Entrada = {
    CrearRegistroSelInputMessage: l_CrearRegistroSelInputMessage,
  };

  return retorno;
}

export function builtCrearRegistroInputMessage(
  idPreReg: string,
  cuenta: string,
  password: string,
  email: string,
  telf: string,
  servicio: string,
  tipo: string
) {
  var retorno: CrearRegistroSelInputMessage = {
    IdPreReg: idPreReg,
    Cuenta: cuenta,
    Password: password,
    Email: email,
    Telf: telf,
    Servicio: servicio,
    Tipo: tipo,
  };
  return retorno;
}

export function builtCrearRegistroRest_Entrada(
  l_CrearRegistroSelInputMessage: CrearRegistroSelInputMessage
) {
  var retorno: CrearRegistroRest_Entrada = {
    CrearRegistroSelInputMessage: l_CrearRegistroSelInputMessage,
  };
  return retorno;
}

export function builtCrearRegistroSelInputMessage(
  l_IdPreReg: string,
  l_Cuenta: string,
  l_Password: string,
  l_Email: string,
  l_Telf: string,
  l_Servicio: string,
  l_Tipo: string
) {
  var retorno: CrearRegistroRest_Entrada = builtCrearRegistroRest_Entrada(
    builtCrearRegistroInputMessage(
      l_IdPreReg,
      l_Cuenta,
      l_Password,
      l_Email,
      l_Telf,
      l_Servicio,
      l_Tipo
    )
  );

  return retorno;
}

export type CrearRegistroRest_Respuesta = EncabezadoRespuestaInterna;
